import React, { memo } from "react";
import { useIntl } from "react-intl";
import { LocalizedText } from "../../../i18n/LocalizedText.js";
import "@mui/material";
import "../../../tooltip/Tooltip.js";
import "moment-timezone";
import "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
import "../../../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../tooltip/AutoAdjustedComplexTooltip.styles.js";
import { MultiLineAutoAdjustedWidthTooltip } from "../../../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import { getGridEmptyValue } from "./utils.js";
const GridTextFormatter = memo(({ label }) => {
  return /* @__PURE__ */ React.createElement(LocalizedText, { label });
});
const renderCellHeader = (label) => {
  return /* @__PURE__ */ React.createElement(MultiLineAutoAdjustedWidthTooltip, { linesCount: 2 }, /* @__PURE__ */ React.createElement(GridTextFormatter, { label }));
};
function MuiTextCell({ value, emptyPlaceholder }) {
  return value ? /* @__PURE__ */ React.createElement(MultiLineAutoAdjustedWidthTooltip, { linesCount: 1 }, /* @__PURE__ */ React.createElement(LocalizedText, { label: value })) : /* @__PURE__ */ React.createElement(React.Fragment, null, emptyPlaceholder);
}
function renderMuiGridStringTextCell(params) {
  const value = params.value;
  const emptyPlaceholder = getGridEmptyValue(params.row);
  return /* @__PURE__ */ React.createElement(MuiTextCell, { value, emptyPlaceholder });
}
function renderMuiGridLocalizedTextCell(params) {
  const { formatMessage } = useIntl();
  const message = params.value;
  const value = message ? formatMessage(message) : null;
  const emptyPlaceholder = getGridEmptyValue(params.row);
  return /* @__PURE__ */ React.createElement(MuiTextCell, { value, emptyPlaceholder });
}
export {
  GridTextFormatter,
  renderCellHeader,
  renderMuiGridLocalizedTextCell,
  renderMuiGridStringTextCell
};
//# sourceMappingURL=TextCell.js.map
